<template>
  <div @click="passMethod('click')">
    <svg class="iconpark-icon default-icon" :class="classes">
      <use class="default-icon" :href="`#${name}`"></use>
    </svg>
  </div>
</template>

<script>
import themeMixins from '@mixins/officialTopupNew/themeMixins';
export default {
  mixins: [themeMixins],
  props: {
    name: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="scss" scoped>
.default-icon {
  width: 100%;
  height: 100%;
}
</style>
